<div *ngIf="cargando" class="flex justify-center items-center min-h-screen">
  <div class="flex flex-col items-center">
    <div class="spinner-border animate-spin inline-block w-12 h-12 border-4 border-t-transparent border-azul rounded-full" role="status"></div>
    <p class="mt-4 text-lg text-azul">{{'cargando-detalles-partido' | translate}}</p>
  </div>
</div>
<div *ngIf="!cargando">
  <div class="grid grid-cols-1 md:grid-cols-2 p-5 gap-5">
    <!-- Equipos Partido -->
    <div class="col-span-1 animate-fade-right">
      <div class="grid grid-cols-3">
        <!-- Equipo Local -->
        <div class="col-span-1 flex flex-col justify-center items-center py-2 cursor-pointer" (click)="consultarEquipo(partido.equipos[0].ID)">
          <img src="{{partido.equipos[0].escudo}}" alt="{{partido.equipos[0].nombre}}" class="w-32 h-32 object-contain">
          <p class="p-2 text-center">{{partido.equipos[0].nombre}}</p>
        </div>
        <div class="col-span-1 flex flex-col justify-center items-center py-2">
          <span *ngIf="partido.estado != 'enjuego'" class="font-bold text-azul text-xl my-2 lg:my-0">{{ partido.resultado }}</span>
          <span>{{ partido.fecha | date: 'dd/MM/yyyy'}}</span>
        </div>
        <!-- Equipo Visitante -->
        <div class="col-span-1 flex flex-col justify-center items-center py-2 cursor-pointer" (click)="consultarEquipo(partido.equipos[1].ID)">
          <img src="{{partido.equipos[1].escudo}}" alt="{{partido.equipos[1].nombre}}" class="w-32 h-32 object-contain">
          <p class="p-2 text-center">{{partido.equipos[1].nombre}}</p>
        </div>
      </div>
    </div>
    <!-- Detalles del Partido -->
    <div class="col-span-1 animate-fade-left">
      <div class="w-full bg-azul rounded-lg p-2">
        <h1 class="text-center text-white text-xl">{{'detallesPartido' | translate}}</h1>
      </div>
      <div class="flex flex-col justify-center items-center">
        <div class=" w-full border-b p-1">
          <p class="text-center">{{'estadio' | translate}} {{partido.equipos[0].estadio}}</p>
        </div>
        <div class=" w-full border-b p-1">
          <p class="text-center">{{'fecha' | translate}} {{ partido.fecha | date: 'dd/MM/yyyy'}}</p>
        </div>
        <div class=" w-full border-b p-1">
          <p class="text-center">{{'hora' | translate}} {{partido.fecha | date: 'HH:mm'}}</p>
        </div>
        <div class=" w-full border-b p-1">
          <p class="text-center">{{'clima' | translate}} {{partido.clima.toUpperCase()}}</p>
        </div>
        <div class=" w-full border-b p-1">
          <p class="text-center">{{'asistencia' | translate}} {{partido.asistencia}}</p>
        </div>
      </div>
    </div>
  </div>
  <div>
    <!-- Contenedor Estadisticas y Alineaciones -->
    <mat-tab-group>
      <!-- Estadisticas Equipos -->
      <mat-tab label="{{'estadisticasEquipos' | translate}}">
        <div class="grid grid-cols-2 animate-fade-up">
          <!-- Equipo Local -->
          <div class="flex flex-col items-center justify-center space-y-2 p-5">
            <h1 class="p-2 text-center">{{ partido.equipos[0].nombre }}</h1>
            <img [src]="partido.equipos[0].escudo" alt="{{partido.equipos[0].nombre}}" class="w-32 h-32 object-contain" />
            <!-- Posesion -->
            <div class="flex flex-col items-center justify-center space-y-2">
              <div class="text-lg">
                {{'posesion' | translate}}
                <span [countUp]="actuacionesEquipos[0].posesion"></span>
                %
              </div>                  
              <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [value]="actuacionesEquipos[0].posesion"></mat-progress-spinner>
            </div>                 
          </div>
          <!-- Equipo Visitante -->
          <div class="flex flex-col items-center justify-center space-y-2 p-5">
            <h1 class="p-2 text-center">{{ partido.equipos[1].nombre }}</h1>
            <img [src]="partido.equipos[1].escudo" alt="{{partido.equipos[1].nombre}}" class="w-32 h-32 object-contain" />
            <!-- Posesion -->
            <div class="flex flex-col items-center justify-center space-y-2">
              <div class="text-lg">
                {{'posesion' | translate}}
                <span [countUp]="actuacionesEquipos[1].posesion"></span>%
              </div>                  
              <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [value]="actuacionesEquipos[1].posesion"></mat-progress-spinner>
            </div> 
          </div>
        </div>
        <!-- Contenedor Estadisticas Totales -->
        <div class="flex flex-col items-center justify-center w-full my-5 px-5 space-y-6 animate-fade animate-delay-1000">
          <!-- Tiros -->
          <div class="w-full max-w-xl space-y-1">
            <h1 class="text-center font-semibold text-sm text-gray-700">{{'tirosTotales' | translate}}</h1>
            <div class="bg-gray-200 rounded overflow-hidden h-6 flex shadow">
              <div class="bg-azul text-white text-xs h-full flex items-center justify-center" [ngStyle]="{ width: porcentajeTirosTotalesEquipo1 + '%' }">{{ actuacionesEquipos[0].tiros_totales }}</div>
              <div class="bg-red-600 text-white text-xs h-full flex items-center justify-center" [ngStyle]="{ width: porcentajeTirosTotalesEquipo2 + '%' }">{{ actuacionesEquipos[1].tiros_totales }}</div>
            </div>
          </div>
          <!-- Tiros Porteria -->
          <div class="w-full max-w-xl space-y-1">
            <h1 class="text-center font-semibold text-sm text-gray-700">{{'tirosPorteria' | translate}}</h1>
            <div class="bg-gray-200 rounded overflow-hidden h-6 flex shadow">
              <div class="bg-azul text-white text-xs h-full flex items-center justify-center" [ngStyle]="{ width: porcentajeTirosPorteriaEquipo1 + '%' }">{{ actuacionesEquipos[0].tiros_porteria }}</div>
              <div class="bg-red-600 text-white text-xs h-full flex items-center justify-center"[ngStyle]="{ width: porcentajeTirosPorteriaEquipo2 + '%' }">{{ actuacionesEquipos[1].tiros_porteria }}</div>
            </div>
          </div>
          <!-- Faltas -->
          <div class="w-full max-w-xl space-y-1">
            <h1 class="text-center font-semibold text-sm text-gray-700">{{'faltasRecibidas' | translate}}</h1>
            <div class="bg-gray-200 rounded overflow-hidden h-6 flex shadow">
              <div class="bg-azul text-white text-xs h-full flex items-center justify-center" [ngStyle]="{ width: porcentajeFaltasRealizadasEquipo1 + '%' }">{{ actuacionesEquipos[0].faltas_realizadas }}</div>
              <div class="bg-red-600 text-white text-xs h-full flex items-center justify-center" [ngStyle]="{ width: porcentajeFaltasRealizadasEquipo2 + '%' }">{{ actuacionesEquipos[1].faltas_realizadas }}</div>
            </div>
          </div>
          <!-- Corners a Favor -->
          <div class="w-full max-w-xl space-y-1">
            <h1 class="text-center font-semibold text-sm text-gray-700">{{'cornersFavor' | translate}}</h1>
            <div class="bg-gray-200 rounded overflow-hidden h-6 flex shadow">
              <div class="bg-azul text-white text-xs h-full flex items-center justify-center" [ngStyle]="{ width: porcentajeCornersFavorEquipo1 + '%' }">{{ actuacionesEquipos[0].corners_favor }}</div>
              <div class="bg-red-600 text-white text-xs h-full flex items-center justify-center" [ngStyle]="{ width: porcentajeCornersFavorEquipo2 + '%' }">{{ actuacionesEquipos[1].corners_favor }}</div>
            </div>
          </div>
          <!-- Corners Contra -->
          <div class="w-full max-w-xl space-y-1">
            <h1 class="text-center font-semibold text-sm text-gray-700">{{'cornersContra' | translate}}</h1>
            <div class="bg-gray-200 rounded overflow-hidden h-6 flex shadow">
              <div class="bg-azul text-white text-xs h-full flex items-center justify-center" [ngStyle]="{ width: porcentajeCornersContraEquipo1 + '%' }">{{ actuacionesEquipos[0].corners_contra }}</div>
              <div class="bg-red-600 text-white text-xs h-full flex items-center justify-center" [ngStyle]="{ width: porcentajeCornersContraEquipo2 + '%' }">{{ actuacionesEquipos[1].corners_contra }}</div>
            </div>
          </div>
        </div>
      </mat-tab>
      <!-- Alineaciones -->
      <mat-tab label="{{'alineaciones' | translate}}">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-5 p-5">
          <!-- Alineacion Equipo Local -->
          <div class="col-span-1 md:col-span-2">
            <h2 class="text-xl text-center text-azul">{{ partido.equipos[0].nombre }}</h2>
          </div>
          <div class="col-span-1">
            <img [src]="'data:image/jpeg;base64,' + alienacionesPartido[0].imagen_alineacion" alt="alineacion" class="w-full h-auto object-contain rounded-lg"/>
          </div>
          <div class="col-span-1">
            <div *ngFor="let jugador of jugadoresEquipoLocal">
              <div class="p-2 border-b grid grid-cols-3 justify-between cursor-pointer" (click)="perfilJugador(jugador.id)">
                <span class="col-span-1 w-7 h-7 rounded-full text-center bg-azul text-white p-1">{{jugador.dorsal}}</span>
                <span class="col-span-1 text-center">{{jugador.nombre}}</span>
                <span class="col-span-1 text-center">{{jugador.posicion.toUpperCase()}}</span>
              </div>
            </div>
          </div>
          <!-- Alineacion Equipo Visitante -->
          <div class="col-span-1 md:col-span-2">
            <h2 class="text-xl text-center text-azul">{{ partido.equipos[1].nombre }}</h2>
          </div>
          <div class="col-span-1">
            <img [src]="'data:image/jpeg;base64,' + alienacionesPartido[1].imagen_alineacion" alt="alineacion" class="w-full h-auto object-contain rounded-lg"/>
          </div>
          <div class="col-span-1">
            <div *ngFor="let jugador of jugadoresEquipoVisitante">
              <div class="p-2 border-b grid grid-cols-3 justify-between cursor-pointer" (click)="perfilJugador(jugador.id)">
                <span class="col-span-1 w-7 h-7 rounded-full text-center bg-azul text-white p-1">{{jugador.dorsal}}</span>
                <span class="col-span-1 text-center">{{jugador.nombre}}</span>
                <span class="col-span-1 text-center">{{jugador.posicion.toUpperCase()}}</span>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
